export function chunk<T>(array: readonly T[], size: number): T[][] {
	if (!Number.isSafeInteger(size) || size <= 0) {
		throw new RangeError("size must be an integer greater than 0");
	}

	const chunks: T[][] = [];

	for (let i = 0; i < array.length; i += size) {
		chunks.push(array.slice(i, i + size));
	}

	return chunks;
}
